import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { useGameStore } from '../../core/store';
import { play as playAudio } from '../audio';
import './stadium.css';

/** Blackout → stadium stills/gifs → portfolio reveal. */
export function StadiumBeat() {
  const finishStadium = useGameStore((s) => s.finishStadium);
  const root = useRef<HTMLDivElement>(null);
  const [slide, setSlide] = useState(0);
  const done = useRef(false);

  useEffect(() => {
    playAudio('cheer', { gain: 1.1 });
    const timers: number[] = [];

    // Black hold
    timers.push(
      window.setTimeout(() => setSlide(1), 500),
      window.setTimeout(() => setSlide(2), 1800),
      window.setTimeout(() => setSlide(3), 3200),
      window.setTimeout(() => {
        if (done.current) return;
        done.current = true;
        gsap.to(root.current, {
          opacity: 0,
          duration: 0.6,
          ease: 'power2.in',
          onComplete: () => finishStadium(),
        });
      }, 4800),
    );

    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [finishStadium]);

  return (
    <div className="stadium" ref={root}>
      <div className={`stadium__black${slide === 0 ? ' is-on' : ''}`} />
      <div
        className={`stadium__slide stadium__slide--a${slide >= 1 ? ' is-on' : ''}`}
        aria-hidden
      />
      <div
        className={`stadium__slide stadium__slide--b${slide >= 2 ? ' is-on' : ''}`}
        aria-hidden
      />
      <div
        className={`stadium__slide stadium__slide--c${slide >= 3 ? ' is-on' : ''}`}
        aria-hidden
      />
      <p className="stadium__caption">The Final</p>
    </div>
  );
}
